module.exports = __webpack_public_path__ + "img/transfer10.03d91eae.jpeg";